import { Alert, Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    hasExistingXm: boolean,
    existingXmStaus: string,
    onConfirmRequest: () => void,
    onCancel: () => void
}

const ExmRequest = (props: IProps) => {
    return (
        <Modal show={props.show} backdrop='static' onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Exploratory XM Request</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Alert bsStyle='info' className='text-center'>
                    Confirm the EXM request by clicking the "Confirm Request" button below
                </Alert>

                {props.hasExistingXm && (
                    <Alert bsStyle='danger' className='text-center'>
                        WARNING: There is already an existing, {props.existingXmStaus} Exploratory XM for this donor. Continuing will result in a duplicate.
                    </Alert>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onConfirmRequest}>Confirm Request</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ExmRequest;